(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14774);
/* harmony import */ var _components_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55480);
/* harmony import */ var _components_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44775);
/* harmony import */ var _lib_renderSegmentSnippet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35453);









var Wrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head__WEBPACK_IMPORTED_MODULE_3__/* .HeadContent */ .Q, {}),
             true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "segment",
                dangerouslySetInnerHTML: {
                    __html: (0,_lib_renderSegmentSnippet__WEBPACK_IMPORTED_MODULE_5__/* .renderSegmentSnippet */ .w)("9AXppxupYYlAb8xFD1CbnAVVRYmqJcR4")
                }
            }) : 0,
            children
        ]
    });
};
var Layout = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_page__WEBPACK_IMPORTED_MODULE_4__/* .Page */ .T, {
                children: children
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 56442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ModalsProvider; },
/* harmony export */   "o": function() { return /* binding */ useModals; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89211);
/* harmony import */ var unstated_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88305);




var initialTitle = "This feature is available exclusively on the Ladder iPhone app";
var initialDescription = "Discover a workout plan for every day that's easy to follow, can be done from anywhere, and is new each week.";
var useContainer = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), appLockedPromptOpen = ref[0], setAppLockedPromptOpen = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(false), 2), showQRModal = ref1[0], toggleShowQRModal = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialTitle), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialDescription), description = ref3[0], setDescription = ref3[1];
    var handleClose = function() {
        setAppLockedPromptOpen(false);
        setTitle(initialTitle);
        setDescription(initialDescription);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!appLockedPromptOpen) {
            setTimeout(function() {
                setTitle(initialTitle);
                setDescription(initialDescription);
            }, 500);
        }
    }, [
        appLockedPromptOpen
    ]);
    return {
        showQRModal: showQRModal,
        toggleShowQRModal: toggleShowQRModal,
        appLockedPromptOpen: appLockedPromptOpen,
        setAppLockedPromptOpen: setAppLockedPromptOpen,
        title: title,
        setTitle: setTitle,
        description: description,
        setDescription: setDescription,
        handleClose: handleClose
    };
};
var ref = (0,unstated_next__WEBPACK_IMPORTED_MODULE_3__/* .createContainer */ .f)(useContainer), useModals = ref.useContainer, ModalsProvider = ref.Provider;



/***/ }),

/***/ 48333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ DesktopQRModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/qr-code/QRCode.js
var QRCode = __webpack_require__(43705);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./lib/misc.js
var misc = __webpack_require__(8016);
;// CONCATENATED MODULE: ./hooks/useUrlShortener.js




var getShortUrl = function(longUrl) {
    return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (longUrl) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 2:
                    _ctx.next = 4;
                    return (0,misc/* fetcher */._i)("/api/shorten-url", {
                        method: "POST",
                        body: JSON.stringify({
                            longUrl: longUrl
                        })
                    });
                case 4:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var useUrlShortener = function(longUrl, initialData) {
    var ref = (0,es.useQuery)(longUrl && "/api/shorten-url/".concat(longUrl), getShortUrl(longUrl), {
        initialData: initialData
    }), data = ref.data, error = ref.error, isLoading = ref.isLoading;
    return {
        data: data,
        error: error,
        isLoading: isLoading
    };
};

// EXTERNAL MODULE: ./components/workout/misc.js
var workout_misc = __webpack_require__(25858);
// EXTERNAL MODULE: ./components/modals/container.js
var container = __webpack_require__(56442);
;// CONCATENATED MODULE: ./components/modals/desktop-qr-modal.js







var DesktopQRModal = function(param) {
    var launchProgramID = param.launchProgramID, _title = param.title, title = _title === void 0 ? "GET THE LADDER APP" : _title, _description = param.description, description = _description === void 0 ? "Scan to download the Ladder iOS app!" : _description;
    var ref;
    var cancelButtonRef = (0,react.useRef)(null);
    var ref1 = (0,container/* useModals */.o)(), showQRModal = ref1.showQRModal, toggleShowQRModal = ref1.toggleShowQRModal;
    var deepLink = (0,workout_misc/* useHandleClickCTA */.V)(launchProgramID, "GET THE APP").deepLink;
    var ref2 = useUrlShortener(deepLink), data = ref2.data, error = ref2.error, isLoading = ref2.isLoading;
    var shortUrl = data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Root */.uT.Root, {
        show: showQRModal,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Dialog */.Vq, {
            as: "div",
            style: {
                zIndex: 100
            },
            className: "fixed inset-0 overflow-y-auto",
            initialFocus: cancelButtonRef,
            onClose: toggleShowQRModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-center justify-center hidden min-h-screen px-4 pt-4 pb-20 text-center sm:flex sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Dialog.Overlay */.Vq.Overlay, {
                            className: "fixed inset-0 transition-opacity bg-white/50 backdrop-blur-sm"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Transition.Child */.uT.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative inline-block px-4 pt-5 pb-6 overflow-hidden text-left align-bottom transition-all transform border shadow-xl bg-dark-slanted-gradient border-space-200 rounded-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:pt-6 sm:px-12 sm:pb-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "py-6 mb-2 text-4xl tracking-wide text-center text-white uppercase 2xl:text-5xl font-display",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-center p-6 mx-auto transition-transform duration-150 ease-in-out bg-white border border-black shadow-2xl rounded-3xl",
                                    style: {
                                        width: 330,
                                        height: 330
                                    },
                                    children: error ? "Something went wrong. Please refresh and try again." : shortUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QRCode/* QRCode */.s, {
                                        size: 280,
                                        logoSize: 0,
                                        value: shortUrl
                                    }) : "Loading..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-3 pb-3 space-x-2 text-xl font-bold text-center 2xl:text-2xl text-lemon",
                                    children: description
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 98700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Notice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_text_node__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12284);



function Notice() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "w-full px-4 py-3 text-sm text-center text-white bg-black border-b border-gray-700 notice center md:text-sm lg:px-12 lg:text-base",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text_node__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
            as: "span",
            at: "notice.home"
        })
    });
};


/***/ }),

/***/ 43705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ QRCode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1653);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var QRCode = function(param) {
    var _value = param.value, value = _value === void 0 ? "QR Code" : _value, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_qr_code__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        value: value,
        size: size
    });
};


/***/ }),

/***/ 25858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useHandleClickCTA; }
/* harmony export */ });
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93335);
/* harmony import */ var _modals_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56442);
/* harmony import */ var _lib_captureEvent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75507);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8016);




var useHandleClickCTA = function(launchProgramID) {
    var CTALabel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "SEE MORE WORKOUTS";
    var isDesktop = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_0__/* .useIsDesktop */ .Ce)();
    var toggleShowQRModal = (0,_modals_container__WEBPACK_IMPORTED_MODULE_1__/* .useModals */ .o)().toggleShowQRModal;
    var baseUrl = new URL("https://ladder.page.link?ibi=com.ladder.bootcamp&isi=1502936453&ius=ladderteams");
    var baseDeepLink = new URL("https://joinladder.com".concat(launchProgramID ? "?launchProgramID=".concat(launchProgramID) : ""));
    var link = (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .updateUTMParams */ .m2)(baseDeepLink, "_appdirect");
    var deepLink = new URL(baseUrl);
    deepLink.searchParams.set("link", link);
    var href = isDesktop ? (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .updateUTMParams */ .m2)("https://offers.joinladder.com/survey", "_homepagesurvey") : deepLink;
    var handleClickCta = function() {
        var ref;
        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_2__/* .captureEvent */ .e)({
            category: "workout",
            action: "workout_cta_clicked",
            label: CTALabel,
            value: isDesktop ? "Show QR Modal" : href === null || href === void 0 ? void 0 : (ref = href.toString) === null || ref === void 0 ? void 0 : ref.call(href)
        });
        if (isDesktop) {
            toggleShowQRModal(true);
        } else {
            window.open(href, "_blank");
        }
    };
    return {
        handleClickCta: handleClickCta,
        deepLink: deepLink,
        href: href
    };
};


/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23333);
/* harmony import */ var _components_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55480);
/* harmony import */ var _components_home__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42899);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42469);
/* harmony import */ var _components_modals_container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56442);
/* harmony import */ var _components_modals_desktop_qr_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48333);
/* harmony import */ var _components_nav__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44401);
/* harmony import */ var _components_notice_home__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98700);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(30784);
/* harmony import */ var _helpers_misc__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56554);













var Content = function() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), query = ref.query, isReady = ref.isReady;
    var toggleShowQRModal = (0,_components_modals_container__WEBPACK_IMPORTED_MODULE_7__/* .useModals */ .o)().toggleShowQRModal;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isReady) return;
        if (!query.showAppDownloadQR) return;
        toggleShowQRModal();
    }, [
        query,
        isReady,
        toggleShowQRModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_notice_home__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_nav__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                showWWOD: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "h-full max-w-full overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home__WEBPACK_IMPORTED_MODULE_5__/* .HomeComponent */ .Ol, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_3__/* .Footer */ .$, {})
                ]
            })
        ]
    });
};
var defaultLink = "https://ladder.page.link/?ibi=com.ladder.bootcamp&isi=1502936453&ius=ladderteams&link=https://".concat(_helpers_misc__WEBPACK_IMPORTED_MODULE_12__/* .isDev */ .r8 ? "dev." : "", "joinladder.com");
function Home() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head__WEBPACK_IMPORTED_MODULE_4__/* .HeadContent */ .Q, {
                title: "Ladder | Your Daily Workout Plan"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_state_containers_experiment__WEBPACK_IMPORTED_MODULE_11__/* .ExperimentProvider */ .I, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_modals_container__WEBPACK_IMPORTED_MODULE_7__/* .ModalsProvider */ .$, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modals_desktop_qr_modal__WEBPACK_IMPORTED_MODULE_8__/* .DesktopQRModal */ .B, {
                            title: "Download the app!",
                            description: "Scan the QR code start your workout",
                            deepLink: defaultLink
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {})
                    ]
                })
            })
        ]
    });
};
Home.Layout = _components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z; // export async function getStaticPaths() {
 //   const experiment = getCurrentExperiment()
 //   return {
 //     paths: experiment.variants.map((v) => ({
 //       params: { variant: `${experiment.id}.${v.id}` },
 //     })),
 //     fallback: false,
 //   }
 // }


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,7409,6308,1664,3041,5980,5322,6727,7905,2075,2265,1653,1033,5181,4875,4401,7792,4858,2899,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);